import { render, staticRenderFns } from "./RankingModal.vue?vue&type=template&id=32711d95&scoped=true"
import script from "./RankingModal.vue?vue&type=script&lang=ts"
export * from "./RankingModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32711d95",
  null
  
)

export default component.exports